import styled from 'styled-components';
import Review1 from '../../../assets/images/pluvaAutoLanding/review1.gif';
import Review2 from '../../../assets/images/pluvaAutoLanding/review2.gif';
import { Icon } from '../../../components/common/icon/Icon';
import { YoutubeSection } from '../../../components/common/video/YoutubeSection';

interface IReview {
  summary: string;
  primaryUseAndLocation: string;
  youtubeUrl?: string;
  gifUrl?: string;
  name: string;
}

const reviews: IReview[] = [
  {
    summary: '플루바 오토 달아서 야간 작업을 했는데 야간인데도 골이 잘 잡힌거 같아요.',
    primaryUseAndLocation: '전라남도 무안, 고구마 농사',
    gifUrl: Review1,
    name: '강행원',
  },
  {
    summary: '이앙기 운전은 플루바 오토에 맡기고\n저는 뒤에서 모판 교체해요.',
    primaryUseAndLocation: '경상북도 상주, 논/콩/축사',
    gifUrl: Review2,
    name: '민인규',
  },
];

const ReviewBox = ({ review }: { review: IReview }) => {
  const starCount = 5;
  const { summary, primaryUseAndLocation, youtubeUrl, gifUrl, name } = review;
  return (
    <ReviewContainer>
      {gifUrl && <ReviewGif src={gifUrl} />}
      {youtubeUrl && <YoutubeSection youtubeUrl={youtubeUrl} />}
      <ReviewContentSection>
        <ReviewSummaryBox>
          <ReviewInfoSummaryText>{summary}</ReviewInfoSummaryText>

          <UserInfo>
            <PrimaryUseAndLocationText>{primaryUseAndLocation}</PrimaryUseAndLocationText>

            <UserNameAndStartRatingWrapper>
              <UserName>{`${name} 고객님`}</UserName>
              <StarRatingBox>
                <StarRating>
                  {Array.from({ length: starCount }, (_, index) => (
                    <Icon key={index} name={'Star'} width={20} height={20} fill={'#FF9500'} />
                  ))}
                </StarRating>
                <StarCount>{starCount.toFixed(1)}</StarCount>
              </StarRatingBox>
            </UserNameAndStartRatingWrapper>
          </UserInfo>
        </ReviewSummaryBox>
      </ReviewContentSection>
    </ReviewContainer>
  );
};

export const CustomerReviewSection = () => {
  return (
    <Container>
      <ReviewGroup>
        {reviews.map((review: IReview) => {
          return <ReviewBox key={review.summary} review={review} />;
        })}
      </ReviewGroup>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 0px 24px 48px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
`;

const ReviewGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const ReviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  overflow: hidden;

  border-radius: var(--radius-medium, 8px);
`;

const ReviewGif = styled.img`
  border-radius: var(--radius-none, 0px);
  background: var(--Light-Scheme-Monochrome-black, #232429);
`;

const ReviewContentSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--radius-small, 4px);
  align-self: stretch;
`;

const PrimaryUseAndLocationText = styled.div`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);

  /* Display/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
`;

const ReviewSummaryBox = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  border-radius: var(--radius-none, 0px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const ReviewInfoSummaryText = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--radius-small, 4px);
  align-self: stretch;
`;

const UserNameAndStartRatingWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--radius-medium, 8px);
  align-self: stretch;
`;

const UserName = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/Medium/m-bold */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 18.2px */
`;

const StarRatingBox = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(--radius-small, 4px);
  flex: 1 0 0;
  align-self: stretch;
`;

const StarRating = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StarCount = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 18.2px */
`;
